import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import HomePage from "@/pages/HomePage";
import EpisodesPage from "@/pages/EpisodesPage";
import EpisodeDetailPage from "@/pages/EpisodeDetailPage";
import AboutPage from "@/pages/AboutPage";
import ShiSipsPage from "@/pages/ShiSipsPage";
import MusicPage from "@/pages/MusicPage";
import ShowsPage from "@/pages/ShowsPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import NotFoundPage from "@/pages/NotFoundPage";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          window.__lenis
            ? window.__lenis.scrollTo(el, { offset: -90 })
            : el.scrollIntoView({ behavior: "smooth" });
        }
      }, 400);
      return () => clearTimeout(timer);
    }
    window.__lenis
      ? window.__lenis.scrollTo(0, { immediate: true })
      : window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-ink text-cream">
      <div className="grain" aria-hidden="true" />
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/shows" element={<ShowsPage />} />
            <Route path="/episodes" element={<EpisodesPage />} />
            <Route path="/episodes/:slug" element={<EpisodeDetailPage />} />
            <Route path="/shi-report" element={<Navigate to="/" replace />} />
            <Route path="/shi-report/:slug" element={<Navigate to="/" replace />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/shi-sips" element={<ShiSipsPage />} />
            <Route path="/music" element={<MusicPage />} />
            <Route path="/song-of-the-week" element={<Navigate to="/music" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1F140F",
            border: "1px solid #36261E",
            color: "#F4ECE1",
          },
        }}
      />
    </div>
  );
}

export default App;
